import { Paper, styled } from '@mui/material';

export const BasePaper = styled(Paper)(() => ({
    margin: '20px 0px',
    padding: '20px'
  }));
  